const t = "lbergeronsfdevt1z2624x", n = (r, e) => e === !1 ? !1 : e === !0 ? !0 : r === t;
export {
  n as shouldMockAgentConfiguration
};
//# sourceMappingURL=ShouldMockAgentConfiguration.js.map
